import classNames from 'classnames';
import React, { useRef } from 'react';
import Avatar from "react-avatar";
import {
    CabinetTreeActionAddIcon, CabinetTreeActionDeleteIcon,
    CabinetTreeActionEditIcon,
    CabinetTreeActionIcon,
    MenuNavPeoplesIcon
} from "../../components/Public/markup/icons";
import useClickPast from "../../hooks/useClickPast";
import useObjectState from '../../hooks/useObjectState';
import './style.scss';
import useElementPosition from '../../hooks/useElementPosition';
import useCompanyRole from '../../hooks/useCompanyRole';


const DepartmentCard = props => {
    const {
        title,
        employees,
        generalDirector,
        onDrop,
        onDragOver,
        onDragEnter,
        onDragLeave,
        onDragStart,
        isDraggedOver,
        onAddSubDepartment,
        status,
        childrensCount,
        showChildrens,
        setShowChildrens,
        createSubdivisionModal,
        createUserInfoModal,


        onDelete,

        openUserInfoModal,
        department,
        openEditDepModal,
        openCreateUser
    } = props;

    const dropEmployeId = `employeDropZone-${department.id}`;

    const dropGendirId = `gendirDropZone-${department.id}`;
    const cardRef = useRef(null)
    const position = useElementPosition(cardRef, 150)

    const { state: { showAllEmployers, showActionList, gendirDropZone, employeDropZone }, setValue, setValues } = useObjectState({
        showAllEmployers: false,
        showActionList: false,
        showChildDepartments: true,
        gendirDropZone: false,
        employeDropZone: false
    })

    const node = useClickPast(() => { setValue("showAllEmployers", false) });
    const actionListRef = useClickPast(() => setValue("showActionList", false), ({ target }, { current }) => {
        if (current?.contains?.(target) || target?.closest?.('.department-card__action-list')) return
        setValue("showActionList", false);
    });

    const isReadOnly = useCompanyRole(["full_access_departament"]);

    const emplZoneRef = useRef()

    const gendirDropZoneRef = useRef()

    const clickToAction = action => {
        const actions = {
            addDepartment: () => onAddSubDepartment(title),
            editDepartment: openEditDepModal,
            deleteDepartment: onDelete
        }

        actions[action]();

        setValue("showActionList", false);

    }
    const handleDragEnter = (e) => {
        const enterGenZone = gendirDropZoneRef.current.contains(e.target)

        const enterEmployeeZone = emplZoneRef.current.contains(e.target)

        if (enterEmployeeZone) setValue("employeDropZone", true)

        if (enterGenZone) setValue("gendirDropZone", true)

    }

    const handleDragLeave = (e) => {

        const leaveGenZone = !gendirDropZoneRef.current.contains(e.relatedTarget)

        const leaveEmployeeZone = !emplZoneRef.current.contains(e.relatedTarget)

        if (leaveEmployeeZone) setValue("employeDropZone", false)

        if (leaveGenZone) setValue("gendirDropZone", false)

    }

    const handleDrop = e => {
        onDrop(e)
        setValues({
            gendirDropZone: false,
            employeDropZone: false
        })
    }
    return (
        <div
            className={
                classNames({
                    "department-card": true,
                    "department-card--dragged-over": isDraggedOver,
                    "department-card--general": status === 'general',
                    "department-card--second": status === 'second',
                    "department-card--third": status === 'third',
                    "department-card--last": status === 'last',
                })}

            onDrop={handleDrop}
            onDragOver={onDragOver}
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
            ref={cardRef}
        >
            <h3 className="department-card__title"><span>{title}</span>
                <div ref={actionListRef}>
                    <span className="department-card__action-btn" onClick={() => setValue("showActionList", prev => !prev)}><CabinetTreeActionIcon /></span>
                    {!isReadOnly && showActionList &&
                        <ul className={classNames({ "department-card__action-list": true, right: position.includes("right") })} >
                            {openCreateUser && <li onClick={() => openCreateUser()}>
                                <MenuNavPeoplesIcon />
                                <span>Добавить сотрудника</span>
                            </li>}
                            <li onClick={() => clickToAction("editDepartment")}>
                                <CabinetTreeActionEditIcon />
                                <span>Редактировать</span>
                            </li>
                            {status !== "last" && <li onClick={() => clickToAction("addDepartment")}>
                                <CabinetTreeActionAddIcon />
                                <span>Создать подразделение</span>
                            </li>}

                            <li onClick={() => clickToAction("deleteDepartment")}>
                                <CabinetTreeActionDeleteIcon />
                                <span>Удалить</span>
                            </li>
                        </ul>}
                    {/*<button className="department-card__add-sub" onClick={() => onAddSubDepartment(title)}>+</button>*/}
                </div>
            </h3>
            <div
                id={dropGendirId}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                ref={gendirDropZoneRef}
                style={{ height: generalDirector && !isDraggedOver ? 93 : "auto", maxHeight: 93 }}
            >
                {!isDraggedOver && !gendirDropZone && generalDirector && (
                    <EmployeeCard
                        draggable={status !== 'general'}
                        fullname
                        employee={{ ...generalDirector, position: 'Руководитель' }}
                        onDragStart={(e) => onDragStart(e, generalDirector, true)}
                        className="department-card__general-director"
                        onClick={() => openUserInfoModal({ user: generalDirector, userDepartment: department, isGendir: true })}
                    />
                )}

                {(gendirDropZone || isDraggedOver) && (
                    <div
                        style={{
                            padding: 10,
                            border: "1px dashed #E0E0E0",
                            borderRadius: 4,
                            width: "100%",
                            borderColor: gendirDropZone ? "#E0E0E0" : "white"

                        }}>
                        + Сделать руководителем
                    </div>
                )}
            </div>

            <p style={{ color: '#777A89', paddingTop: 5 }}>Сотрудники {employees.length}</p>
            <div
                className="department-card__employees"
                id={dropEmployeId}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                ref={emplZoneRef}
                style={{ height: !employees?.length && !isDraggedOver ? "auto" : 39, maxHeight: 39, }}
            >

                {!isDraggedOver && !employeDropZone && employees.slice(0, 4).map((employee) => (
                    <EmployeeCard
                        key={employee.id}
                        employee={employee}
                        onDragStart={(e) => onDragStart(e, employee)}
                        onClick={() => openUserInfoModal({ user: employee, userDepartment: department })}
                    />
                ))}
                {(employeDropZone || isDraggedOver) && (
                    <div style={{ padding: 10, width: "100%", border: "1px dashed #E0E0E0", borderRadius: 4, borderColor: employeDropZone ? "#E0E0E0" : "white" }}>
                        + Добавить сотрудника
                    </div>
                )}
                {employees.length > 4 && <span ref={node} onClick={() => setValue("showAllEmployers", prev => !prev)} className="department-card__employees-all">Все
                    <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.7262 7.325L11.7738 4.175" stroke="#777A89" stroke-linecap="round" />
                        <path d="M11.7738 3.825L8.72618 0.675" stroke="#777A89" stroke-linecap="round" />
                        <path d="M11.9643 4.00033L0.75 4.00033" stroke="#777A89" stroke-linecap="round" />
                    </svg>
                </span>}
            </div>

            {employees.length > 4 && showAllEmployers &&
                <ul className="department-card__employees-alllist">
                    {
                        employees.map((employee) => (
                            <li><EmployeeCard
                                key={employee.id}
                                employee={employee}
                                onDragStart={(e) => onDragStart(e, employee)}
                                fullname
                                onClick={() => openUserInfoModal({ user: employee, userDepartment: department })}
                            /></li>
                        ))
                    }
                </ul>
            }
            {!!childrensCount && <div className="department-card__departments-toggle" onClick={childrensCount && setShowChildrens}>
                <span>Подразделения: {childrensCount}</span>
                <span style={{ transform: `rotate(${showChildrens ? 0 : "180deg"})` }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.0551 12.75L12.0001 9.74955L8.94505 12.75" stroke="#EF372E" stroke-linecap="round" /></svg>
                </span>
            </div>}
        </div>
    );
}


const EmployeeCard = ({ employee, onDragStart, fullname, className, onClick = () => { }, draggable = true }) => {

    return (
        <div
            className={className ?? "employee-card"}
            draggable={draggable}
            onDragStart={(e) => onDragStart(e, employee)}
            onClick={onClick}
        >
            {!!employee.photo && <img src={employee.photo?.src} alt={employee.name} className="employee-card__image" />}
            {!employee.photo && <Avatar
                name={employee.name}
                size="40"
                round
                className="employee-card__image"
                textSizeRatio={2.5}
            />}
            {fullname &&
                <div>
                    <div className="employee-card__name">{employee.name}</div>
                    <div className="employee-card__position">{employee.position}</div>
                </div>
            }


        </div>
    )
};

export default DepartmentCard